import { useEffect, useState } from 'react'
import { Button, Container, MenuItem, Select, Typography } from '@mui/material'
import { TEAM_TYPES } from '../../../utility/constants'
import { useAuthContext } from '../../../hooks/useAuthContext'
import Masonry from 'react-masonry-css'
import TeamUserCard from './TeamUserCard'
import AddEditUserDialog from './AddEditUserDialog'
import AddEditTeamDialog from './AddEditTeamDialog'
import { adminTeamsService } from '../../../services/admin/teams'

const breakpoints = {
  default: 3,
  1100: 2,
  700: 1,
}

const UserTeamManagement = () => {
  const { user } = useAuthContext()
  const [users, setUsers] = useState([])
  const [teams, setTeams] = useState([])
  const [userTeamMap, setUserTeamMap] = useState([])
  const [isAddUserDialogOpen, setIsAddUserDialogOpen] = useState(false)
  const [isAddTeamDialogOpen, setIsAddTeamDialogOpen] = useState(false)
  const [selectedTeamType, setSelectedTeamType] = useState('internal')
  const [selectedTeamSubType, setSelectedTeamSubType] = useState('All')
  const [departments, setDepartments] = useState([])
  const [designations, setDesignations] = useState([])

  const [allTeamTypes, setAllTeamType] = useState([])
  const [allTeamSubTypes, setAllTeamSubTypes] = useState([])

  const fetchTeams = async () => {
    const teams = await adminTeamsService.getTeams(user)
    const teamTypesSubTypes = await adminTeamsService.getTeamTypeAndSubTypes(user)

    setTeams(teams)
    setAllTeamType(teamTypesSubTypes.teamTypes || [])
    setAllTeamSubTypes(teamTypesSubTypes?.teamSubTypes || [])
  }

  const fetchUsers = async () => {
    const users = await adminTeamsService.getUsers(user)
    setUsers(users)
  }

  const fetchDepartment = async () => {
    const departments = await adminTeamsService.getDepartmentByCompanyId(user)
    setDepartments(departments)
  }

  const fetchDesignation = async () => {
    const designations = await adminTeamsService.getDesignationByCompanyId(user)
    setDesignations(designations)
  }

  const fetchUserTeamMap = async () => {
    const userTeamMap = await adminTeamsService.getUserTeamMapByCompanyId(user)
    setUserTeamMap(userTeamMap)
  }

  useEffect(() => {
    ;(async () => {
      if (user) {
        await Promise.all([
          fetchUsers(),
          fetchTeams(),
          fetchUserTeamMap(),
          fetchDepartment(),
          fetchDesignation(),
        ])
      }
    })()
  }, [user])

  return (
    users &&
    teams &&
    userTeamMap && (
      <>
        <Container>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: 32,
              alignItems: 'center',
            }}
          >
            <Typography
              variant="h5"
              color="textSecondary"
              style={{ display: 'flex', alignItems: 'center' }}
            >
              <span>Manage Teams&nbsp;&nbsp;</span>
              <div style={{ display: 'flex', gap: '5px', marginTop: '5px' }}>
                <Select
                  size="small"
                  label="Team Type"
                  value={selectedTeamType}
                  onChange={(e) => setSelectedTeamType(e.target.value)}
                >
                  {allTeamTypes.map((it) => {
                    return (
                      <MenuItem key={it} value={it}>
                        {it.toUpperCase()}
                      </MenuItem>
                    )
                  })}
                </Select>
                <Select
                  size="small"
                  label="Team Subtype"
                  value={selectedTeamSubType}
                  onChange={(e) => setSelectedTeamSubType(e.target.value)}
                >
                  <MenuItem value="All">All</MenuItem>
                  {allTeamSubTypes.map((it) => {
                    return (
                      <MenuItem key={it} value={it}>
                        {it.toUpperCase()}
                      </MenuItem>
                    )
                  })}
                </Select>
              </div>
            </Typography>
            <div>
              <Button
                color="primary"
                variant="contained"
                type="button"
                size="small"
                onClick={() => setIsAddUserDialogOpen(true)}
              >
                Add Edit User
              </Button>
              &nbsp;&nbsp;
              <Button
                color="primary"
                variant="contained"
                size="small"
                type="button"
                onClick={() => setIsAddTeamDialogOpen(true)}
              >
                Add Edit Team
              </Button>
            </div>
          </div>
          <Masonry
            breakpointCols={breakpoints}
            className="my-masonry-grid"
            columnClassName="my-masonry-grid_column"
          >
            {teams
              .filter(
                (t) =>
                  t.team_type == selectedTeamType &&
                  (selectedTeamSubType === 'All' || t.team_subtype === selectedTeamSubType)
              )
              .map((t) => (
                <TeamUserCard
                  key={t.id}
                  team={t}
                  teamUserIds={userTeamMap
                    .filter((it) => t.id == it.team_id)
                    .map((it) => it.user_id)}
                  users={users}
                />
              ))}
          </Masonry>
        </Container>
        {/* Add/Edit User */}
        <AddEditUserDialog
          departments={departments}
          designations={designations}
          users={users}
          isOpen={isAddUserDialogOpen}
          setOpenClose={(it) => setIsAddUserDialogOpen(it)}
          fetchFreshList={fetchUsers}
        />
        {/* Add / Edit Team Dialog*/}
        <AddEditTeamDialog
          teams={teams}
          isOpen={isAddTeamDialogOpen}
          setCloseOpen={(v) => setIsAddTeamDialogOpen(v)}
          fetchFreshList={fetchTeams}
          allTypes={allTeamTypes}
          allSubTypes={allTeamSubTypes}
        />
      </>
    )
  )
}

export default UserTeamManagement
